module.exports = __webpack_public_path__ + "img/hero-student-illustration.8fda9f55.svg";